import {
    takeLatest, all, put, call, take, fork,
} from 'redux-saga/effects';
import { eventChannel, END } from 'redux-saga';
import _ from 'lodash';
import API from '../common/API';
import { waitAuthorizedCheck } from './Auth';
import * as Actions from '../actions/LiveStreamManagement';

// API get list live stream for admin and organizer
function* getListLiveStream(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/live_stream/`,
                body: {
                    ...action.payload,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.GetListLiveStreamEventReceived(response));
    } catch (error) {
        yield put(Actions.GetListLiveStreamEventReceivedFailure(yield error));
    }
}

function* getDetailLiveStream(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/live_stream/${action.payload.live_stream_id}/`,
                body: {},
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailLiveStreamEventReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailLiveStreamEventReceivedFailure(yield error));
    }
}

function* updateLiveStream(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const endpoint = `/api/v1/event/${action.payload.event_name}/live_stream/${action.payload.live_stream_id}/`;
        const body = action.payload;
        const [uploadPromise, channel] = createUploadChannel({ live_stream_id: body.live_stream_id, ...body.data }, credential.data.token, endpoint);
        yield fork(uploadProgressWatcher, channel);

        const response = yield call(() => uploadPromise);
        yield put(Actions.UpdateDetailLiveStreamEventReceived(response));
    } catch (error) {
        yield put(Actions.UpdateDetailLiveStreamEventReceivedFailure(yield error));
    }
}

function createUploadChannel(payload, token, endpoint) {
    let emit;
    const chan = eventChannel((emitter) => {
        emit = emitter;
        // it's necessarily. event channel should
        // return unsubscribe function. In our case
        // it's empty function
        return () => { };
    });

    const onProgress = (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        emit(percentCompleted);
        if (percentCompleted === 100) emit(END); // 100 percent emit end
        else emit(percentCompleted);
    };

    const uploadPromise = API.putWithFile({
        endpoint,
        body: payload,
        token,
        onProgress,
    });

    return [uploadPromise, chan];
}

function* uploadProgressWatcher(channel) {
    while (true) {
        const progress = yield take(channel);
        yield put(Actions.UpdateLivestreamProgress(progress));
    }
}

function* adminDeleteLiveStream(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.delete,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/live_stream/${action.payload.live_stream_id}/`,
                body: {},
                token: credential.data.token,
            },
        );
        yield put(Actions.AdminDeleteLiveStreamEventReceived(response));
    } catch (error) {
        yield put(Actions.AdminDeleteLiveStreamEventReceivedFailure(yield error));
    }
}

function* viewerGetListLiveStream(action) {
    try {
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/unregistered_live_stream/`,
                body: {
                    ...action.payload,
                },
            },
        );
        yield put(Actions.ViewerGetListLiveStreamEventReceived(response));
        yield put(Actions.AddDateGetListLiveStreamEventReceived({ ...response.results }));
    } catch (error) {
        yield put(Actions.ViewerGetListLiveStreamEventReceivedFailure(yield error));
    }
}

function* viewerGetListLiveStreamLoginAcc(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/unregistered_live_stream/`,
                body: {
                    ...action.payload,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.ViewerGetListLiveStreamLoginAccReceived(response));
        yield put(Actions.AddDateGetListLiveStreamLoginAccReceived({ ...response.results }));
    } catch (error) {
        yield put(Actions.ViewerGetListLiveStreamLoginAccReceivedFailure(yield error));
    }
}

function* viewerRegisterLiveStream(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/live_stream/register/?language=${action.payload.language}`
        : '/api/v1/live_stream/register/';
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.post,
            {
                endpoint,
                body: {
                    ...{ ...action.payload.language ? action.payload.data : action.payload },
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.ViewerRegisterLiveStreamReceived(response));
    } catch (error) {
        yield put(Actions.ViewerRegisterLiveStreamReceivedFailure(yield error));
    }
}

function* viewerListLivestreamRegistered(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/event/${action.payload.event_name}/registered_live_stream/?language=${action.payload.language}`
        : `/api/v1/event/${action.payload.event_name}/registered_live_stream/`;
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint,
                body: {
                    ...action.payload,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.ViewerGetListLivestreamRegisteredReceived(response));
        yield put(Actions.ViewerAddDateGetListRegisteredLivestreamRecevied({ ...response.results }));
    } catch (error) {
        yield put(Actions.ViewerGetListLivestreamRegisteredReceivedFailure(yield error));
    }
}

function* viewerGetDetailLiveStream(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/event/${action.payload.event_name}/live_stream_time/${action.payload.live_stream_id}/?language=${action.payload.language}`
        : `/api/v1/event/${action.payload.event_name}/live_stream_time/${action.payload.live_stream_id}/`;
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint,
                body: {},
                token: credential.data.token,
            },
        );
        yield put(Actions.ViewerGetDetailLivestreamReceived(response));
    } catch (error) {
        yield put(Actions.ViewerGetDetailLivestreamReceivedFailure(yield error));
    }
}

export default function* LiveStreamManagement() {
    yield all([
        takeLatest('GET_LIST_LIVE_STREAM_EVENT_REQUESTED', getListLiveStream),
        takeLatest('GET_DETAIL_LIVE_STREAM_EVENT_REQUESTED', getDetailLiveStream),
        takeLatest('UPDATE_DETAIL_LIVE_STREAM_EVENT_REQUESTED', updateLiveStream),
        takeLatest('ADMIN_DELETE_LIVE_STREAM_EVENT_REQUESTED', adminDeleteLiveStream),
        takeLatest('VIEWER_GET_LIST_LIVE_STREAM_EVENT_REQUESTED', viewerGetListLiveStream),
        takeLatest('VIEWER_REGISTER_LIVE_STREAM_REQUESTED', viewerRegisterLiveStream),
        takeLatest('VIEWER_GET_LIST_LIVESTREAM_REGISTERED_REQUESTED', viewerListLivestreamRegistered),
        takeLatest('VIEWER_GET_DETAIL_LIVESTREAM_REQUESTED', viewerGetDetailLiveStream),
        takeLatest('VIEWER_GET_LIST_LIVE_STREAM_LOGIN_ACC_REQUESTED', viewerGetListLiveStreamLoginAcc),
    ]);
}
